/* =============================================================================
 * M.M.LaFleur — "Shop this look" on Category tiles (v4.7.4, Tier 2 "Shop This
 * Look Functionality Expanded").
 *
 * Merchandising builds landing pages (OrigamiTech, Visonà) from mood images in
 * Category tiles and wanted each image to be shoppable. A tile with products
 * picked under "Shop this look" in the theme editor gets a button; clicking it
 * opens the same right-hand drawer the PDP uses, filled with that tile's
 * pieces, each with a size select and Add to bag, plus Add all to bag.
 *
 * HOW IT FITS THE EXISTING DRAWER
 * - The rows are snippets/mm_look_item.liquid, rendered server-side into a
 *   <template> beside each tile, so sizes, availability and prices are the
 *   same markup the PDP drawer shows.
 * - Adding to the bag is NOT reimplemented: mm-editorial.js already handles
 *   [data-mm-look-add] and [data-mm-look-add-all] clicks site-wide, and
 *   mm-look.js fills those attributes when a size is chosen.
 * - Opening and closing IS handled here, because mm-editorial.js's setLook()
 *   only ever drives the first [data-mm-look] on the page. The tile drawer is
 *   built once per page, on first use, and appended to <body>.
 *
 * The tile itself is one <a>, so the button sits next to it (a button inside a
 * link is invalid and the click would navigate). The listener runs on the
 * capture phase and stops propagation — the theme's house pattern for
 * anything competing with Barba's link handling.
 * ========================================================================== */

(function () {
  "use strict";

  if (window.__mmTileLookBound) return;
  window.__mmTileLookBound = true;

  var drawer = null;
  var scrim = null;
  var lastTrigger = null;

  function build() {
    if (drawer) return;
    var host = document.createElement("div");
    host.className = "mm-scope mm-tlook-host";
    host.innerHTML =
      '<div class="mm-look-scrim" data-mm-tlook-scrim data-open="false"></div>' +
      '<aside class="mm-look" data-mm-tlook-drawer data-open="false" role="dialog" aria-modal="true" aria-label="Shop this look" inert>' +
        '<div class="mm-look-hero">' +
          '<img data-mm-tlook-img alt="" loading="lazy">' +
          '<div class="mm-look-hero-bar">' +
            '<div>' +
              '<p class="mm-eyebrow" style="color:color-mix(in oklab, var(--mm-bone) 80%, transparent)">The Look</p>' +
              '<h3 data-mm-tlook-title>Shop this look</h3>' +
            '</div>' +
            '<button type="button" data-mm-tlook-close aria-label="Close">' +
              '<svg class="mm-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="mm-look-body"><ul data-mm-tlook-list></ul></div>' +
        '<div class="mm-look-foot">' +
          '<button type="button" data-mm-look-add-all="" disabled>Add all to bag</button>' +
          '<p class="mm-look-note" data-mm-look-note hidden></p>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(host);
    drawer = host.querySelector("[data-mm-tlook-drawer]");
    scrim = host.querySelector("[data-mm-tlook-scrim]");
  }

  /* Same rule as mm-look.js: Add all only offers pieces that are ready. */
  function refreshAddAll() {
    if (!drawer) return;
    var all = drawer.querySelector("[data-mm-look-add-all]");
    var note = drawer.querySelector("[data-mm-look-note]");
    var ids = [];
    var waiting = 0;
    drawer.querySelectorAll("[data-mm-look-item]").forEach(function (row) {
      var btn = row.querySelector("[data-mm-look-add]");
      if (!btn) return;
      var id = btn.getAttribute("data-mm-look-add");
      if (id) ids.push(id);
      else if (row.querySelector("[data-mm-look-select]")) waiting += 1;
    });
    if (all) {
      all.setAttribute("data-mm-look-add-all", ids.join(","));
      all.disabled = ids.length === 0;
    }
    if (note) {
      if (waiting > 0) {
        note.textContent = waiting === 1
          ? "Choose a size for 1 more piece to add everything."
          : "Choose a size for " + waiting + " more pieces to add everything.";
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }
  }

  function open(trigger) {
    var tpl = document.getElementById(trigger.getAttribute("data-mm-tile-look"));
    if (!tpl) return;
    build();

    var list = drawer.querySelector("[data-mm-tlook-list]");
    list.innerHTML = "";
    list.appendChild(tpl.content.cloneNode(true));

    var img = drawer.querySelector("[data-mm-tlook-img]");
    var hero = drawer.querySelector(".mm-look-hero");
    var src = trigger.getAttribute("data-mm-tlook-img") || "";
    img.hidden = !src;
    if (src) img.src = src;
    /* No tile image: collapse the photo band to a short ink bar so the
       heading and close button still sit on a dark ground. */
    hero.style.height = src ? "" : "7rem";
    hero.style.background = src ? "" : "var(--mm-ink)";
    /* Fit or Fill, per tile (Category tiles > Tile > Drawer image). Read
       from the button so each tile's drawer keeps its own setting; a button
       rendered before the setting existed falls back to Fit. */
    if (src) {
      hero.setAttribute("data-fit", trigger.getAttribute("data-mm-tlook-fit") || "contain");
    } else {
      hero.removeAttribute("data-fit");
    }

    var title = trigger.getAttribute("data-mm-tlook-title") || "Shop this look";
    drawer.querySelector("[data-mm-tlook-title]").textContent = title;
    drawer.setAttribute("aria-label", title);

    refreshAddAll();

    lastTrigger = trigger;
    drawer.removeAttribute("inert");
    drawer.setAttribute("data-open", "true");
    scrim.setAttribute("data-open", "true");
    trigger.setAttribute("aria-expanded", "true");
    document.body.classList.add("mm-no-scroll");
    var close = drawer.querySelector("[data-mm-tlook-close]");
    if (close) close.focus({ preventScroll: true });
  }

  function shut() {
    if (!drawer || drawer.getAttribute("data-open") !== "true") return;
    drawer.setAttribute("data-open", "false");
    drawer.setAttribute("inert", "");
    scrim.setAttribute("data-open", "false");
    document.body.classList.remove("mm-no-scroll");
    if (lastTrigger) {
      lastTrigger.setAttribute("aria-expanded", "false");
      lastTrigger.focus({ preventScroll: true });
    }
  }

  document.addEventListener("click", function (event) {
    var t = event.target;
    if (!t || !t.closest) return;

    var trigger = t.closest("[data-mm-tile-look]");
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
      return;
    }
    if (t.closest("[data-mm-tlook-close]") || t.closest("[data-mm-tlook-scrim]")) {
      event.preventDefault();
      event.stopPropagation();
      shut();
    }
  }, true);

  /* Runs after mm-look.js has written the chosen variant onto the row. */
  document.addEventListener("change", function (event) {
    if (!drawer || !drawer.contains(event.target)) return;
    window.setTimeout(refreshAddAll, 0);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") shut();
  });
}());
